import LeafCrown from '../src/LeafCrown';
export default LeafCrown;
